/* eslint-disable id-length */
import React from "react";
import Link from "helpers/link";

const BlogLinks = ({ children, value }) => <Link className="rich-text-new__link rich-text-new__link--blog" to={value.href}>{children}</Link>;
const HomepageLinks = ({ children, value }) => <Link className="rich-text-new__link rich-text-new__link--homepage" to={value.href}>{children}</Link>;
const NoStyleLinks = ({ children, value }) => <Link className="rich-text-new__link" to={value.href}>{children}</Link>;

export const richTextNewTemplate = {
    Homepage: {
        block: {
            h1: ({ children }) => <h1 className="rich-text-new__heading rich-text-new__heading--h1 rich-text-new__heading--homepage">{children}</h1>,
            h2: ({ children }) => <h2 className="rich-text-new__heading rich-text-new__heading--h2 rich-text-new__heading--homepage">{children}</h2>,
            h3withTick: ({ children }) => (
                <h3 className="rich-text-new__heading rich-text-new__heading--h3 rich-text-new__heading--h3-with-tick rich-text-new__heading--homepage">
                    <span className="rich-text-new__tick"> · </span>
                    {children}
                </h3>
            ),  
            h3: ({ children }) => <h3 className="rich-text-new__heading rich-text-new__heading--h3 rich-text-new__heading--homepage">{children}</h3>,
            h4: ({ children }) => <h4 className="rich-text-new__heading rich-text-new__heading--h4 rich-text-new__heading--homepage">{children}</h4>,
            normal: ({ children }) => <p className="rich-text-new__paragraph rich-text-new__paragraph--homepage">{children}</p>,         
            normalWithTick: ({ children }) => (
                <p className="rich-text-new__paragraph rich-text-new__paragraph--with-tick rich-text-new__paragraph--homepage">
                    <span className="rich-text-new__tick"> . </span>
                    {children}
                </p>
            ),    
            span: ({ children }) => <span className="rich-text-new__span rich-text-new__span--homepage">{children}</span>,
        },
        marks: {
            link: HomepageLinks,
            strong: ({ children }) => <strong className="rich-text-new__strong rich-text-new__strong--homepage">{children}</strong>,
        },
        list: { bullet: ({ children }) => <ul className="rich-text-new__list rich-text-new__list--bullet rich-text-new__list--homepage">{children}</ul> },
        listItem: {
            bullet: ({ children }) => (
                <li className="rich-text-new__list-item rich-text-new__list-item--bullet rich-text-new__list-item--homepage"> 
                    {children}
                </li>
            ), 
            number: ({ children }) => (
                <li className="rich-text-new__list-item rich-text-new__list-item--number rich-text-new__list-item--homepage"> 
                    {children}
                </li>
            ), 
        },
    },
    Blog: {
        block: {
            h1: ({ children }) => <h1 className="rich-text-new__heading rich-text-new__heading--h1 rich-text-new__heading--blog">{children}</h1>,
            h2: ({ children }) => <h2 className="rich-text-new__heading rich-text-new__heading--h2 rich-text-new__heading--blog">{children}</h2>,
            h3: ({ children }) => <h3 className="rich-text-new__heading rich-text-new__heading--h3 rich-text-new__heading--blog">{children}</h3>,
            h4: ({ children }) => <h4 className="rich-text-new__heading rich-text-new__heading--h4 rich-text-new__heading--blog">{children}</h4>,
            normal: ({ children }) => <p className="rich-text-new__paragraph rich-text-new__paragraph--blog">{children}</p>,           
            span: ({ children }) => <span className="rich-text-new__span rich-text-new__span--blog">{children}</span>,
        },
        marks: {
            link: BlogLinks,
            strong: ({ children }) => <strong className="rich-text-new__strong rich-text-new__strong--blog">{children}</strong>,
        },
        list: {
            bullet: ({ children }) => <ul className="rich-text-new__list rich-text-new__list--bullet rich-text-new__list--blog">{children}</ul>,
            number: ({ children }) => <ul className="rich-text-new__list rich-text-new__list--number rich-text-new__list--blog">{children}</ul>, 
        },
        listItem: {
            bullet: ({ children }) => (
                <li className="rich-text-new__list-item rich-text-new__list-item--bullet rich-text-new__list-item--blog"> 
                    {children}
                </li>
            ),
            number: ({ children }) => (
                <li className="rich-text-new__list-item rich-text-new__list-item--number rich-text-new__list-item--blog">                    
                    {children}
                </li>
            ),
        
        },
    },
    NoStyle: {
        block: {
            h1: ({ children }) => <h1 className="rich-text-new__heading rich-text-new__heading--h1">{children}</h1>,
            h2: ({ children }) => <h2 className="rich-text-new__heading rich-text-new__heading--h2">{children}</h2>,
            h3: ({ children }) => <h3 className="rich-text-new__heading rich-text-new__heading--h3">{children}</h3>,
            h4: ({ children }) => <h4 className="rich-text-new__heading rich-text-new__heading--h4">{children}</h4>,
            normal: ({ children }) => <p className="rich-text-new__paragraph">{children}</p>,           
            span: ({ children }) => <span className="rich-text-new__span">{children}</span>,
        },
        marks: {
            link: NoStyleLinks,
            strong: ({ children }) => <strong className="rich-text-new__strong">{children}</strong>,
        },
        list: {
            bullet: ({ children }) => <ul className="rich-text-new__list rich-text-new__list--bullet">{children}</ul>,
            number: ({ children }) => <ul className="rich-text-new__list rich-text-new__list--number">{children}</ul>, 
        },
        listItem: {
            bullet: ({ children }) => (
                <li className="rich-text-new__list-item rich-text-new__list-item--bullet"> 
                    {children}
                </li>
            ),
            number: ({ children }) => (
                <li className="rich-text-new__list-item rich-text-new__list-item--number">                    
                    {children}
                </li>
            ),
        
        },
    },
};

export default richTextNewTemplate;
